module.exports = __webpack_public_path__ + "static/numbers-3-1-22ff6e7b322c02800dff38cff81f975d.png";